// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaOrcamentosSemCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_orcamentos_sem_compromisso
 *
 * Returns array of orcamento records without compromissos.
 */
import type { GestaoClientes_CarregaOrcamentosSemCompromissoRow } from './GestaoClientes_CarregaOrcamentosSemCompromissoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaOrcamentosSemCompromissoResponseDados = GestaoClientes_CarregaOrcamentosSemCompromissoRow[];

export type GestaoClientes_CarregaOrcamentosSemCompromissoResponse = ApiResponse<GestaoClientes_CarregaOrcamentosSemCompromissoResponseDados>;

registerResponseContract('GestaoClientes_CarregaOrcamentosSemCompromissoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:                      { type: 'number',  required: true },
      acoes:                   { type: 'string',  required: true },
      agendar:                 { type: 'string',  required: true },
      status:                  { type: 'string',  required: true },
      status_label:            { type: 'string',  required: true },
      orcamento_data:          { type: 'string',  required: true },
      orcamento_franquia_id:   { type: 'string',  required: true },
      nome_cliente:            { type: 'string',  required: false },
      pode_agendar:            { type: 'string',  required: true },
      agendar_motivos:         { type: 'array',   required: false },
      cliente_id:              { type: 'string',  required: true },
      cliente_ddi:             { type: 'string',  required: false },
      cliente_ddd:             { type: 'string',  required: false },
      cliente_telefone:        { type: 'string',  required: false },
      rua:                     { type: 'string',  required: false },
      bairro:                  { type: 'string',  required: false },
      orcamento_location_id:   { type: 'string',  required: false },
      orcamento_location_type: { type: 'string',  required: false },
      total:                   { type: 'string',  required: false },
      origem:                  { type: 'string',  required: false },
      franquia:                { type: 'string',  required: false },
      Localidade:              { type: 'string',  required: false },
    },
  },
})
